function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, Ref, ElementType, ChangeEventHandler, CSSProperties, HTMLAttributes } from 'react';
import cn from 'classnames';
require("./RadioButton.css");
var styles = {
  "Root": "RadioButton-module-Root_3Li",
  "checked": "RadioButton-module-checked_1Ln",
  "disabled": "RadioButton-module-disabled_AcE",
  "Input": "RadioButton-module-Input_15-",
  "Label": "RadioButton-module-Label_26E"
};
export const RadioButton = ({
  checked = false,
  className,
  controlRef,
  disabled = false,
  innerRef,
  name,
  onChange,
  style = {},
  tag = 'span',
  value,
  label,
  ...props
}) => {
  const Component = tag;
  return /*#__PURE__*/React.createElement(Component, {
    className: cn(styles.Root, {
      [styles.checked]: checked,
      [styles.disabled]: disabled
    }, [className]),
    ref: innerRef,
    style: style
  }, /*#__PURE__*/React.createElement("input", _extends({}, props, {
    ref: controlRef,
    checked: checked,
    disabled: disabled,
    className: styles.Input,
    onChange: onChange,
    type: "radio",
    name: name,
    value: value,
    id: value + 'ID'
  })), label && /*#__PURE__*/React.createElement("label", {
    htmlFor: value + 'ID',
    className: styles.Label
  }, label));
};
if (process.env.NODE_ENV !== 'production') {
  RadioButton.displayName = 'RadioButton';
}